/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * ToggleSynchronySubmitOrderButton Input Action
 */
export class ToggleSubmitOrderButtonInput implements Msdyn365.IActionInput {
    //   Construct the input needed to run the action
    constructor() {}

    //   Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `toggle-submit-order-button`;
    public getCacheObjectType = () => 'toggle-submit-order-button';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

//   Create a data model here or import one to capture the response of the action
export interface IToggleSubmitOrderButtonData {
    isSynchronySelected: boolean;
    isPaypalSelected: boolean;
    isCreditcardSelected: boolean;
    isCcFieldsNotPopulated: boolean;
    isProgressiveSelected: boolean;
}

/**
 *   Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new ToggleSubmitOrderButtonInput();
};

/**
 *   Use this function to call your action and process the results as needed
 */
async function action(input: ToggleSubmitOrderButtonInput, ctx: Msdyn365.IActionContext): Promise<IToggleSubmitOrderButtonData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    //   Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IToggleSubmitOrderButtonData[]>('/get/example/id/1', 'get');
    return { isSynchronySelected: false, isPaypalSelected: false, isCreditcardSelected: false, isCcFieldsNotPopulated: true, isProgressiveSelected: false };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IToggleSubmitOrderButtonData>>action,
    //   Give your data action a unique id
    id: 'ToggleSubmitOrderButton',
    input: createInput
    //   Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
